import { useTranslation } from 'react-i18next';
import styles from './Helper.module.css';
import Button from 'components/library/Button/Button';
import type { ConfigState } from 'services/store/features/Config/types';

interface Props {
  config: ConfigState;
}

export default function Header({
  config,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.helperContainer}>
      <div className={styles.helperText}>
        <h3 className={styles.helperTitle}>{t('eligible.helper.title')}</h3>
        <div className={styles.fullWidth}>
          <div className={styles.hr} />
        </div>
        <p className={styles.helperSubTitle}>{t('eligible.helper.subtitle')}</p>
        <Button
          className={styles.submitButton}
          variant="fill"
          type="secondary"
          label={t('navigation.takeRdv')}
          onButtonClick={() => window.open(config.calendly)}
        />
      </div>
    </div>
  );
}
